import { useRegions } from "../../admin/dictionaries/useRegions";
import SearchableMultiSelectFilter from "./SearchableMultiSelectFilter";
import { useSearchParamArray } from "./useSearchParamArray";

export function PackageRegionFilter(props: { paramName: string }) {
  const [values, setValues] = useSearchParamArray(props.paramName);
  const { regions = [] } = useRegions();
  return (
    <SearchableMultiSelectFilter
      label="Region"
      options={regions.map((region) => ({ label: region.name, value: region.id.id }))}
      selectedValues={values}
      onChange={setValues}
    />
  );
}
